import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { LocationService, ProviderService, ProviderServiceService } from '../../services';
import ServiceModel from '../../data/entities/booking/ServiceModel';
import { useAsync, useUrlParams } from '../../hooks';
import { useParams } from 'react-router-dom';

interface SearchableServiceDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  placeholder?: string;
}

export const SearchableServiceDropdown = React.forwardRef(
  (
    props: Readonly<SearchableServiceDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const [options, setOptions] = useState<DropdownOption[]>([]);
    const locationService = new LocationService();
    const providerServiceService = new ProviderServiceService();

    const providerId = parseInt(useUrlParams("providerId"));
    const locationId = parseInt(useUrlParams("id"));

    useEffect(() => {
      const fetchData = async () => {
  
        let locationServices = await locationService.getServices(locationId);
        let providerServices = await providerServiceService.getServicesByProviderId(providerId);  
        
        const uniqueServiceIds = new Set<number>(providerServices.map(providerService => providerService.serviceId));
        const services = locationServices.filter(locationService => !uniqueServiceIds.has(locationService.id));

        const newOptions = services
          .map<DropdownOption>((service: ServiceModel) => ({
            value: service.id?.toString() ?? "",
            text: `${service.name}`,
          }))
          .sort((a, b) => a.text.localeCompare(b.text));

        setOptions(newOptions);
      };

      fetchData();
    }, [locationId, providerId]);

    const getValue = () => {
      if (props.value) {
        return options.find((option) => option.value === props.value?.toString());
      }
    }

    return (
      <SearchableDropdown
        defaultItem={{ text: "Select a Service", value: "" }}
        label="Service"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableServiceDropdown
